import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { IDealCryptoPerformanceData } from "store/types";
import { useFormatDateHook } from "hooks";
import { useDateFormatSelect } from "store";

interface ICurrencyPerformanceTable {
  rows: IDealCryptoPerformanceData[];
}

export const CurrencyPerformanceTable: React.FC<ICurrencyPerformanceTable> = ({ rows }) => {
  const formatDate = useFormatDateHook();
  const dateFormat = useDateFormatSelect();

  return (
    <TableContainer
      component={Paper}
      sx={{
        borderRadius: "8px",
        boxShadow: "none",
        border: "0.5px solid #dae0e2"
      }}
    >
      <Table sx={{ maxWidth: "480px" }} aria-label="currency performance table">
        <TableHead sx={{ backgroundColor: "#EDF1F9" }}>
          <TableRow>
            <TableCell sx={{ fontWeight: "bold" }}>Date</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Price</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Market Cap</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Circulating Supply</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index}>
              <TableCell sx={{ fontWeight: "bold" }}>{formatDate({ date: row.date, format: dateFormat })}</TableCell>
              <TableCell>{row.price}</TableCell>
              <TableCell>{row.market_cap}</TableCell>
              <TableCell>{row.circulating_supply}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
